module.exports = __webpack_public_path__ + "img/philippines.f2fe035.webp";